module.exports = __webpack_public_path__ + "img/camp04_actived.a4c8d1f6.png";